module.exports = {
  sentryEnabled: false,
  recaptchaSiteKey: "6Ld0coQrAAAAABxZ0JkfiQZc1w5epJ8e7auFZm-c",
  coreApi: {
    protocol: "https",
    host: "api-dev-gcp.ct-production.net",
  },
};
